<template>
    <div v-if="this.$route.query['error']" class="pa-5 justify-center align-center">
        <div>В работе страницы произшел сбой:
        {{error}}</div>
        <v-btn @click.stop="cancel">Вернуться назад</v-btn>
    </div>
</template>

<script>

    export default {
        props: {
            errorMessage: String
        },
        computed: {
            error() {
                return this.$route.query['error'] || this.errorMessage
            }
        },
        methods: {
            end(query) {
                query = Object.assign(query, this.$route.query)
                let baseUrl = window.location.toString().split('?')[0]
                let queryString = Object.entries(query).map(entry => entry.join('=')).join('&')
                window.location = [baseUrl, queryString].join('?')
            },
            cancel() {

                  if (this.isAndroid || this.isIOS) { 

                                 this.end({
                    'cancel': true,
                    'error': this.errorMessage
                })

                  }

     
            }

        },
        created() {
            if (!this.$route.query['cancel'] && !this.$route.query['error']) {
                this.cancel()
            }
        }
    }
</script>

<style>

</style>